import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    driver_license_required_by_client: process.env.REQUIRED_UNINSURED_DL_PICTURE,
    dl_or_ssn_required_by_client: process.env.REQUIRED_UNINSURED_DL_OR_SSN,
    allow_dl_or_ssn: process.env.ALLOW_UNINSURED_DL_OR_SSN,
    logo: process.env.CLIENT_LOGO,
    billingType: 'card',
    paid: false,
    cashPayment: 'true',
    paymentFailedMotive: '',
    stripeToken: '',
    site: {
      code: '',
      name: '',
      address: ''
    },
    results: {
      user: {},
      site: {
        name: '',
        address: '',
        disclaimer: ''
      }
    },
    matchUser: {
      firstName: '',
      lastName: '',
      dob: '',
      email: '',
      address: '',
      gender: '',
      phone: '',
      race: '',
      ethnicity: '',
      confirmation_number: '',
      isCompleted: '',
      result: '',
      patientid: ''
    },
    payment: {
      tokenid: '',
      amount_paid: '',
      transaction_id: '',
      paid: '',
      email: '',
      number: false,
      expiry: false,
      cvc: false,
      cardZip: '',
      complete: false,
      cardHolderName: ''
    },
    ethnicity: '',
    race: '',
    gender: '',
    allows_client_bill: false,
    questions: [{
      question: '',
      answer_type: '',
      answer: ''
    }],
    insurance: '',
    lang: {
      value: 'EN'
    },
    translation_es: '',
    translation_zh: '',
    dataForInsurance: {
      first_name: '',
      last_name: '',
      dob: '',
      gender: ''
    },
    allow_consent: false,
    allow_insurance: true,
    registration_wizardKey: 1,
    registration_tab_index: 0,
    registration_site_code: ''
  },
  getters: {},
  mutations: {
    setLang (state, lang) {
      this.state.lang = lang
    },
    resetPatientRegistrationSettings () {
      this.state.site.code = ''
      this.state.allow_consent = false
      this.state.allow_insurance = true
      this.state.registration_wizardKey = 1
      this.state.registration_tab_index = 0
    }
  },
  actions: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js